<div *ngIf="!ready">
  <H1>Waiting on cards data</H1>
  <kendo-loader
    size="large"
  >
  </kendo-loader>
</div>

<app-irrigation-valve-card-link [filelinkBack]="filelinkBack"  >
</app-irrigation-valve-card-link>



<div *ngFor="let card of jsonCards?.JSONCards ;let y = index">
  <div [ngSwitch]="card.type">
    <div *ngSwitchCase= "'restcaller'">
      <app-card-department [card]="card" [filelinkBack]="filelinkBack" ></app-card-department>
    </div>

    <div *ngSwitchCase= "'cDEP_STORAGE_AFARM'">
      <app-card-department [card]="card" [filelinkBack]="filelinkBack"  [departmentClass]="'department_afram'"></app-card-department>
    </div>

    <div *ngSwitchDefault>
      <app-card-department [card]="card" [filelinkBack]="filelinkBack"></app-card-department>
    </div>
  </div>
</div>







